import { render, staticRenderFns } from "./Service-Report.vue?vue&type=template&id=4b6ef4d2"
import script from "./Service-Report.vue?vue&type=script&lang=js"
export * from "./Service-Report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports